import React, { useEffect, useState } from "react";
import { Box, Button, Card, CardContent, CardHeader, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Layout from "../../../layout/Layout";
import { smallButton } from "../../../constants/styles";
import { Link, useNavigate } from "react-router-dom";
import { PiCopyLight } from "react-icons/pi";
import { FaCheck } from "react-icons/fa";
import styles from "./Home.module.scss";
import styled from "@emotion/styled";
import Loader from "../../../components/Loader/Loader";
import CRMAPI from "../../../services/crm-api";
import { getDownloadUrlFromPresignedUrl } from "../../../helpers/upload-helper";
import UserAPI from "../../../services/profile-api";
import Swal from "sweetalert2";

import { useDispatch, useSelector } from "react-redux";

import { changeFilterLoader } from "../../../redux/slices/filterSlice";

// components
import FilterButton from "../../../components/Filters/FilterButton";
import SwitchFilter from "../../../components/Filters/SwitchFilter";
import FilterLoader from "../../../components/Loader/FilterLoader";
import DateRangeSelector from "../../../components/Filters/DateRangeSelector";
import UTMDialog from "./UTMDialog/UTMDialog";
import FieldAgentAPI from "../../../services/field-agent-api";

export default function AgentHome() {
  const [report, setReport] = useState(null);

  const { filterLoader } = useSelector((state) => state.filter);
  // const { user, dsacommissionType } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const { fieldAgentReportAPI } = new FieldAgentAPI();

  // const navigate = useNavigate();

  useEffect(() => {
    fetchReportDetails();
  }, [filterLoader]);

  const fetchReportDetails = async () => {
    const res = await fieldAgentReportAPI();
    if (res.ok) {
      setReport(res.data);
    }

    // console.log("res------------", res);

    dispatch(changeFilterLoader(false));
  };

  if (!report) {
    return <Loader />;
  }
  return (
    <Layout>
      <Box className={styles.home__page}>
        <Stack spacing={3}>
          <Card elevation={0} sx={{ py: 1, borderRadius: 3 }}>
            <CardHeader
              action={
                <Box display="flex" justifyContent="flex-end">
                  <DateRangeSelector />
                </Box>
              }
              title={
                <Box className="header-title">
                  <Typography variant="h4">Field Agent Performance</Typography>
                </Box>
              }
            />

            <CardContent>
              <Grid container spacing={4}>
                <Grid size={3}>
                  <Box className={styles.dsaPerformance}>
                    <Typography variant="h6">{report.merchant_count}</Typography>
                    <Typography variant="body2">Merchant Registration Count</Typography>
                  </Box>
                </Grid>

                <Grid size={3}>
                  <Box className={styles.dsaPerformance}>
                    <Typography variant="h6">₹{report.payout_amount}</Typography>
                    <Typography variant="body2">Payout Amount</Typography>
                  </Box>
                </Grid>

                <Grid size={3}>
                  <Box className={styles.dsaPerformance}>
                    <Typography variant="h6">₹{report.paid_amount}</Typography>
                    <Typography variant="body2">Paid Amount</Typography>
                  </Box>
                </Grid>

                <Grid size={3}>
                  <Box className={styles.dsaPerformance}>
                    <Typography variant="h6">₹{report.pending_amount}</Typography>
                    <Typography variant="body2">Pending Amount</Typography>
                  </Box>
                </Grid>

                <Grid size={3}>
                  <Box className={styles.dsaPerformance}>
                    <Typography variant="h6">{report.payout_not_given}</Typography>
                    <Typography variant="body2">Payout Not Given</Typography>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Stack>
      </Box>

      {/* Filter Loader */}
      {filterLoader && <FilterLoader />}
    </Layout>
  );
}
